export const LS_FACTOR_SETTINGS = 'factorSettings'
export const LS_CURRENCY_FILTER_LAST_KNOWN = 'currencyFilterLastKnown'
export const LS_TABLE_PREFERENCES = 'tablePreferences'
